import React from "react";
import { NavLink } from "react-router-dom";
import { Home, PlusCircle, History } from "lucide-react";

const NAV_ITEMS = [
  { label: "Home",           to: "/golive",         icon: Home,       end: true },
  { label: "New Deployment", to: "/golive/new",     icon: PlusCircle, end: true },
  { label: "Run History",    to: "/golive/history", icon: History,    end: true },
];

// Previously `fixed top-21 left-70 ...` — hardcoded pixel offsets tied to
// the *old* dashboard header/sidebar dimensions. Those values are stale
// against the redesigned shell (62px topbar, 240/72px sidebar) and would
// misalign the bar. Rendered in-flow now, as a normal pill tab row styled
// with the shared --jade-* tokens (see .gl-subnav* in golive.css) instead
// of a separately-positioned fixed bar.
export default function GoLiveNav() {
  return (
    <nav className="gl-subnav">
      {NAV_ITEMS.map(({ label, to, icon: Icon, end }) => (
        <NavLink
          key={to}
          to={to}
          end={end}
          className={({ isActive }) => `gl-subnav-item${isActive ? " active" : ""}`}
        >
          <Icon size={15} />
          {label}
        </NavLink>
      ))}
    </nav>
  );
}
